export class Diagnostico {
	id: number;
	descricao: string;
	usuarioAlteracao: number;
}